import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return;
}